import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo } from "react";
import { PhoneField, formatPhoneNumber } from "./PhoneField";
import { textInputBaseSlots } from "./TextInputBase";
import { Typography } from "./Typography";
import { SlotsProvider } from "../providers/SlotsProvider";
export const phoneViewInputClasses = {
    root: "MinervaPhoneViewInput-root",
    "uneditable-text": "MinervaPhoneViewInput-uneditableText",
};
export const phoneViewInputSlots = {
    uneditableText: Typography,
};
/**
 * A phone field component that exposes an edit state that allows the phone number to be edited or shown as uneditable text.
 * Note: When edit is set to false, the country code is not shown due to hoisting state limitations. The country code is still present in the value prop.
 */
export const PhoneViewInput = memo(forwardRef(({ className, edit, value, emptyPlaceholder = "—", disableFormatting = false, slots, slotProps, ...rest }, ref) => {
    return (_jsx(SlotsProvider, { baseSlots: { ...phoneViewInputSlots, ...textInputBaseSlots }, slots: slots, children: ({ uneditableText: UneditableText, ...remainingSlots }) => (_jsx(PhoneField, { ref: ref, className: clsx([phoneViewInputClasses.root, className]), value: value, slotProps: slotProps, slots: {
                ...remainingSlots,
                inputRoot: !edit
                    ? () => (_jsx(UneditableText, { variant: "body2", fontWeight: "semibold", className: phoneViewInputClasses["uneditable-text"], ...slotProps?.uneditableText, children: value && value.length > 0 && disableFormatting
                            ? value
                            : value && value.length > 0
                                ? formatPhoneNumber(value)
                                : emptyPlaceholder }))
                    : remainingSlots.inputRoot,
            }, ...rest })) }));
}));
//# sourceMappingURL=PhoneViewInput.js.map